import { BIG_ZERO } from 'config/constants/number'
import { Token } from 'config/types'
import Column from 'layout/Components/Column'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNetwork } from 'state/app/hooks'
import { useTokenSelectedExcludeFiatHUSD } from 'state/session/hooks'
import { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import OpenEffect from 'UIKit/OpenEffect'
import { isFiatNetwork, isHPNNetwork } from 'utils/network'
import { useWaitingDepositToActiveBonus } from 'views/Payment/components/Deposit/DepositCryptos/hooks'
import { PaymentPageEnums } from 'views/Payment/Menu'
import { PAYMENT_MODAL_THEME } from 'views/Payment/MobilePayment/components/styles'
import DepositForm from 'views/Payment/MobilePayment/Deposit/DepositCryptos/DepositForm'
import PaymentNetworkCurrencyDropdown from '../../components/PaymentNetworkCurrencyDropdown'

const DepositCryptos: React.FC<{
  selectedTokenInit: Token
  onBack: () => void
  onRedirect: (page: PaymentPageEnums) => void
}> = ({ selectedTokenInit, onBack, onRedirect }) => {
  const bonusControl = useWaitingDepositToActiveBonus()
  const [isDepositing, setIsDepositing] = useState(false)
  const { t } = useTranslation()
  const playToken = useTokenSelectedExcludeFiatHUSD()
  const [selectedToken, setSelectedToken] = useState<Token>(
    isFiatNetwork(selectedTokenInit.network) || isHPNNetwork(selectedTokenInit.network)
      ? playToken || undefined
      : selectedTokenInit,
  )

  const selectedNetwork = useNetwork(selectedToken?.network)

  return (
    <>
      <ModalHeader
        hideStroke
        titleAlign="left"
        colorTheme={PAYMENT_MODAL_THEME}
        title={t('Deposit Crypto')}
        useBackIcon
        onBack={onBack}
      />
      <ModalBody>
        <OpenEffect openType="grow" duration={0.4}>
          <Column gap="var(--pm-space-component)" height="100%">
            <PaymentNetworkCurrencyDropdown
              hideNetwork
              disabled={isDepositing}
              selectedCurrency={selectedToken}
              onCurrencySelect={(token) => setSelectedToken(token)}
              fetchTokenBalanceFn={async () => {
                return BIG_ZERO
              }}
              hideHUSDToken
            />

            {selectedToken && (
              <DepositForm
                bonusControl={bonusControl}
                isDepositing={isDepositing}
                onChangeDepositing={setIsDepositing}
                selectedToken={selectedToken}
                selectedNetwork={selectedNetwork?.network}
                onRedirectToSwap={() => onRedirect(PaymentPageEnums.Swap)}
              />
            )}
          </Column>
        </OpenEffect>
      </ModalBody>
    </>
  )
}

export default DepositCryptos
